






























































































































import Vue, { PropType } from 'vue'
import { debounce } from 'debounce'
import models from '@/mixins/models-mixin'
import Group from '@/types/Group.interface'
import { randomKey } from '@/utility/helpers'
import Analytics from '@/services/Analytics'
export default Vue.extend({
    mixins: [models],
    props: {
        //  Determines if the type of group select is for broadcasts compose
        broadcastGroupSelector: {
            type: Boolean,
            default: false
        },
        //  Applies the 'clearable' attribute, show the 'clear' icon
        clearable: {
            type: Boolean,
            default: false
        },
        //  Applies the compact style
        compact: {
            type: Boolean,
            default: false
        },
        //  Determines if the component creates a new static group when a new name is entered
        createNew: {
            type: Boolean,
            default: false
        },
        //  Determine is the 'dense' style is applied to the component
        dense: {
            type: Boolean,
            default: false
        },
        //  Determines if the component is disabled
        disabled: {
            type: Boolean,
            default: false
        },
        //  Determines if menu should be expanded
        expanded: {
            type: Boolean,
            default: false,
            required: false
        },
        //  Groups to exclude from our selector groups
        excludeGroups: {
            type: Array,
            default: null
        },
        //  The existing selected group
        group: {
            type: Object as PropType<Group>,
            default: null
        },
        //  The existing multiple selected groups (this requires multiple to be true)
        groups: {
            type: Array as PropType<Group[]>,
            default: null
        },
        //  Applies 'hide-details' styling to the component
        hideDetails: {
            type: Boolean,
            default: false
        },
        //  Hides selected groups from text field
        hideSelection: {
            type: Boolean,
            default: false
        },
        //  The icon displayed in the prepend-icon slot
        icon: {
            type: String,
            default: null
        },
        //  The select's label
        label: {
            type: String,
            default: null
        },
        //  Applies a menu style for selecting an existing group
        menu: {
            type: Boolean,
            default: false
        },
        //  Determines if this is used for selecting multiple groups
        multiple: {
            type: Boolean,
            default: false
        },
        //  The name of the selector (used for collecting error messages)
        name: {
            type: String,
            default: null
        },
        //  Hides the auto-complete list, and returns results in 'searchCompleted' event
        noList: {
            type: Boolean,
            default: false
        },
        //  Omits the drop down icon from the component when True
        omitIcon: {
            type: Boolean,
            default: false
        },
        //  Determine if 'outlined' style is applied to v-select
        outlined: {
            type: Boolean,
            default: false
        },
        //  Custom params for group pagination in getGroups()
        paginateParams: {
            type: Object,
            default: null
        },
        //  The select's placeholder text
        placeholder: {
            type: String,
            default: 'Search or type a new group name'
        },
        //  Adds 'required' groups to the list
        required: {
            type: Boolean,
            default: false
        },
        //  Returns only static groups
        static: {
            type: Boolean,
            default: false
        },
        //  For setting unqiue id where two of the same components might be used
        type: {
            type: String,
            default: null
        },
        //  Forces the selector to remove groups assigned to Autoresponders or Campaigns
        unassigned: {
            type: Boolean,
            default: false
        },
        //  Validation errors delivered by validator on the parent
        validationErrors: {
            type: Object,
            default: null
        },
        //  The maximum width applied to the component
        width: {
            type: String,
            default: '300px'
        }
    },
    data() {
        return {
            expand: false,
            key: randomKey(),
            loading: false,
            searched: null,
            selected: null
        }
    },
    mounted() {
        //  If a group was passed, set our selected
        if (this.group) this.selected = this.group
        //  Else, if groups were passed, set our selected
        else if (this.groups) this.selected = this.groups

        // If the expanded prop is set, we want our menu to be active
        if (this.expanded) {
            //  Setting a 300 millisecond delay to accomodate any transitions
            setTimeout(() => {
                this.$refs.groupSelect.isMenuActive = true
                this.$refs.groupSelect.isFocused = true
                this.$refs.groupSelect.hasColor = true
            }, 300)
        }
    },
    computed: {
        filteredGroups(): Group[] {
            //  If the groups are not loaded yet, do nothing
            if (!this.selectorGroups) return

            //  If the existing group is 'required', return all groups (since we'll need to display a required group)
            if (this.group && this.group.required) return this.selectorGroups

            //  Create a container for filtered groups
            let filtered = this.selectorGroups

            //  If the 'static' props is set, remove query groups
            if (this.static) filtered = filtered.filter((x: Group) => x.query == null)

            //  If the 'unassigned' prop is set, remove groups assigned to Autoresponders/Campaigns
            if (this.unassigned) filtered = filtered.filter((x: Group) => !x.campaign_id)

            //  If the 'required' prop is false, remove required groups
            if (!this.required) filtered = filtered.filter((x: Group) => !x.required)

            //  If the 'excludeGroups' prop is set, remove excluded groups
            if (this.excludeGroups) {
                filtered = filtered.filter(({ id }) => !this.excludeGroups.includes(id))

                //  Remove 0 contact groups, only for broadcasts
                filtered = filtered.filter((x: Group) => x.persons_count != 0)
            }

            //  If searched groups exist, filter them
            if (this.searched) {
                //  Get the searched group's ids
                let ids = new Set(this.searched.map(({ id }) => id))

                //  Filter by id
                filtered = filtered.filter(({ id }) => ids.has(id))
            }

            //  If the selected group is not in the filtered group
            //  list, add it to the beginning
            if (this.group) this.setGroups(filtered, [this.group])

            //  Return the filtered list
            return filtered
        },
        selectorGroups: {
            get(): Group[] {
                return this.$store.getters.groupSelectorGroups
            },
            set(groups: Group[]) {
                this.$store.commit('groupSelectorGroupsSet', groups)
            }
        }
    },
    methods: {
        groupClicked(group: Group): void {
            //  Add group to selected array
            this.selected.push(group)

            //  Get selector element
            var element = document.getElementById(`broadcastSelector${this.type}`)

            //  Remove css class for border
            element.classList.remove('custom-border')

            //  Emit groupSelected event to parent
            this.$emit('groupSelected', this.selected)
        },
        expandList(): void {
            //  Expand group list
            this.expand = true

            //  Get selector element
            var element = document.getElementById(`broadcastSelector${this.type}`)

            //  Add css class for border
            element.classList.add('custom-border')
        },
        unexpand(): void {
            //  Unexpand group list
            this.expand = false

            //  Get selector element
            var element = document.getElementById(`broadcastSelector${this.type}`)

            //  Add css class for border
            element.classList.remove('custom-border')
        },
        //  Clear the selected group
        clear(): void {
            this.selected = null
            this.key = randomKey() //  forces the UI to refresh
        },
        focus(): void {
            this.$refs.groupSelect.focus()
        },
        formatName(name: string): string {
            //  If character length is greater than 15
            if (name.length > 15)
                //  return the first 15 characters along with three dots
                return name.substring(0, 15) + '...'

            //  Else just return the name
            return name
        },
        async groupCreate(group: Group): Promise<Group> {
            //  Start the loading spinner
            this.loading = true

            //  Send the request to the API
            const response = await this.$store.dispatch('groupsPost', group)

            // Stop the loading spinner
            this.loading = false

            //  If the response failed, do nothing
            if (!response) return

            //  Add the new group to the select options
            this.selectorGroups.unshift(response)

            //  Set the selected group
            this.selected = response

            //  Trigger group selected event
            this.onGroupSelected(response)

            //  Notify user of success
            this.$store.commit('appNotificationBarSet', { message: 'Group Created' })
        },
        groupsPaywall(): void {
            return this.$store.dispatch('dialogOpen', {
                type: 'FEATURE',
                paywall_type: 'access',
                metadata: 'group_enabled'
            })
        },
        //  Filter the current list of group by searchtext, publish the event to parent
        onGroupSearch: debounce(function (searchtext: string): void {
            //  If the search text is null or empty, emit null search results
            if (!searchtext) return this.$emit('searchCleared', null)

            //  Else, filter the groups list with the search text
            const results = this.selectorGroups.filter((x: Group) => {
                return x.name.toLowerCase().includes(searchtext.toLowerCase())
            })

            Analytics.track('LocalSearchUsed', {
                search_type: 'Groups',
                search_query: searchtext
            })

            //  Return an array of results
            this.$emit('searchCompleted', results)
        }, 400),
        onGroupSelected(mixed: boolean): void {
            //  If the input does NOT exist, do nothing
            if (!mixed) return

            //  Else, check if the input is a group object
            const isObject = typeof mixed === 'object'

            //  If this is NOT an object then we need to create a group
            if (!isObject) return this.onGroupSelectedGroupCreate(mixed)

            //  Else the input is a group object, emit groupSelected
            this.$emit('groupSelected', mixed)
        },
        onGroupSelectedGroupCreate(mixed: boolean): void {
            //  Make sure the menu closes before showing dialog
            this.$refs.groupSelect.blur()

            //  Else, confirm the user wants to create a new group
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Create new Group?',
                text: `Do you want to create a new group with name: <span class="font-weight-bold">${mixed}</span>.`,
                icon: 'mdi-account-multiple',
                color: 'primary',
                callback: (result: boolean) => {
                    //  If the user answered 'NO' in the dialog, clear the selected text
                    if (!result) return this.clear()

                    //  Else, create a new static group
                    const payload = this.newStaticGroup()

                    //  Update the group's name with string input
                    payload.name = mixed

                    //  POST the group to the api
                    this.groupCreate(payload)
                }
            })
        },
        onSearchCleared(): void {
            //  We use setTimeout here to release the UI before publishing the event. (Rerendering a list of groups is expensive!)
            setTimeout(() => {
                this.$emit('searchCleared')
            }, 250)
        },
        searchFilter: debounce(function (input: string): void {
            // Convert input to lower case as includes() is case sensitive
            input = input.toLowerCase()

            //  Add filtered by search groups to the searched data prop
            this.searched = this.selectorGroups.filter((x: Group) =>
                x.name.toLowerCase().includes(input)
            )
        }, 400),
        setGroups(haystack: Group[], needles: Group[]): void {
            //  Iterate through each of our needles
            needles.forEach((x: Group) => {
                //  Check our haystack for this needle
                const exists = haystack.find((y: Group) => y.id === x.id)

                //  If it does NOT exist, add it to the beginning
                if (!exists) haystack.unshift(x)
            })
        }
    },
    watch: {
        group(val: Group): void {
            this.selected = val
        },
        groups(val: Group[]): void {
            this.selected = val
        },
        selectorGroups(val: Group[]): void {
            //  If a selected group is set then we need to add it to our list if it doesn't already exist
            if (this.group) this.setGroups(val, [this.group])
            //  Do the same if our selected groups is set
            else if (this.groups) this.setGroups(val, this.groups)
        }
    }
})
